import * as React from 'react'
import * as UI from '@brewlogix/blx-ui'

import { Location } from 'src/types/schema/graphql'
import classNames from 'classnames'
import { useStickyNav } from 'src/features/locations/state/useStickyNav'

interface ILocationDescriptionHighlights {
    location: Location
    locationDescriptionRef: React.Ref<HTMLDivElement>
}

const LocationDescriptionHighlights: React.FC<ILocationDescriptionHighlights> = ({
    location,
    locationDescriptionRef,
}) => {
    const { space } = useStickyNav()

    const brandDescription = location?.brand?.description
    const locationDescription = location?.description
    const descriptionText = locationDescription || brandDescription

    const noData = !brandDescription && !locationDescription

    if (noData) return <></>

    return (
        <div
            className={classNames('space-y-4  md:space-y-6', space)}
            id='about'
            ref={locationDescriptionRef}
        >
            <UI.Heading text='About' size='h4' type='h2' customClasses='text-xl lg:text-2xl' />
            <p className=' text-base '>{descriptionText}</p>
        </div>
    )
}

export default LocationDescriptionHighlights
